import { AGENDA_ACTIONS } from 'constants/Actions/Agenda';

// Estado inicial del reducer
const aInitialState = {
    aAgenda: [],
    oAgenda: null,
    aAgendaStatusList: [],
    aAgendaIndividuals: [],
    nNewId: null,
    aAgendaAttachments: [],
    bIsSuccess: false,
    bIsError: false,
    bIsRemove: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a la agenda.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Sebastian Caraballo 
 */
export const AgendaReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case AGENDA_ACTIONS.GET:
            return { ...aState, aAgenda: oAction.data.data };
        case AGENDA_ACTIONS.GET_SINGLE:
            return { ...aState, oAgenda: oAction.data.data };
        case AGENDA_ACTIONS.REMOVE:
            return { ...aState, bIsRemove: true };
        case AGENDA_ACTIONS.GET_INDIVIDUALS:
            return { ...aState, aAgendaIndividuals: oAction.data.data };
        case AGENDA_ACTIONS.GET_STATUS:
            return { ...aState, aAgendaStatusList: oAction.data.data };
        case AGENDA_ACTIONS.GET_ATTACHMENTS:
            return { ...aState, aAgendaAttachments: oAction.data };
        case AGENDA_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case AGENDA_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true, nNewId: oAction.data ? oAction.data.data : null };
        case AGENDA_ACTIONS.CLEAN:
            return { ...aState, aAgenda: [], aAgendaStatusList: [], aAgendaIndividuals: [], oAgenda: null, bIsError: false, bIsSuccess: false, nNewId: null, aAgendaAttachments: [], bIsRemove: false };
        default:
            return aState;
    }
}
